<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import ActionPreview from '../components/GenericView/ActionPreview.svelte';
	import SectionContainer from '../components/GenericView/SectionContainer.svelte';

	export let thens = [];

	const dispatch = createEventDispatcher();
</script>

{#each thens as element, index}
	<SectionContainer class={thens.length - 1 > index ? 'mb-s' : ''}>
		<ActionPreview
			{element}
			on:edit-do={() => {
				dispatch('edit-do', index);
			}}
		/>
	</SectionContainer>
{/each}
